<template>
  <div class="fixed inset-0 flex items-start pt-40 justify-center md:items-center md:pt-0 md:justify-end bg-cover"
    :style="{ backgroundImage: `url(${backgroundImage})`, backgroundPosition: '30% center' }">
    <!-- Logo -->
    <div
      class="absolute left-1/2 -translate-x-1/2 top-12 h-20 w-80 bg-contain bg-no-repeat z-10 md:left-20 md:translate-x-0"
      :style="{ backgroundImage: `url(${logoImage})` }" />

    <!-- Login Card -->
    <div
      class="flex flex-col items-center justify-center gap-8 p-8 w-full max-w-md mx-4 bg-white/80 backdrop-blur-sm rounded-2xl shadow-2xl md:gap-10 md:p-10 md:max-w-lg md:mr-24 md:ml-4">
      <h1 class="text-3xl font-bold text-blue-600 md:text-4xl">
        {{ t('login.title') }}
      </h1>

      <LoginForm />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import LoginForm from './LoginForm.vue'
import backgroundImage from '@/assets/images/light_bc_new.jpg'
import logoImage from '@/assets/images/PClogo.png'

const { t } = useI18n()
</script>
